import { useApiClient } from "@/hooks/useApiClient";
import useSWR, { type SWRResponse } from "swr";

export interface UserMapConfig {
  mapInitLat: number;
  mapInitLon: number;
  mapChibanIsMatch: boolean;
}

/**
 * ユーザーの地図初期設定をSWRで取得するフック。
 * 成功時はユーザー設定の初期表示座標を、失敗時はnullを返す。
 * @returns {SWRResponse<UserMapConfig | null>}
 */
export const GetUserMapConfigAPI = (): SWRResponse<UserMapConfig | null> => {
  const { apiClient } = useApiClient();
  const url = "/user/config/map";

  const fetcher = async (fetchUrl: string): Promise<UserMapConfig | null> => {
    try {
      const response = await apiClient.get<UserMapConfig>(fetchUrl);
      return response.data;
    } catch (error) {
      return null;
    }
  };

  return useSWR(url, fetcher, {
    revalidateOnFocus: false,
    shouldRetryOnError: false, // エラー時にリトライしない
  });
};
